<template>
  <div class="RelatedProperties" v-if="building && building.properties && building.properties.length > 1">
    <h5>{{'Other Properties in this building' | language}}</h5>
    <table>
      <thead>
        <tr>
          <th>{{'Name' | language}}</th>
          <th>{{'Bedrooms' | language}}</th>
          <th>{{'Size' | language}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(property,index) of building.properties" :key="index">
          <td v-if="property.int_property_id !== propertyId">
            <router-link :to="{ name: 'Property', params: { id: property.int_property_id }}">
              {{ language === 'english' ? property.str_property_name_en : property.str_property_name_jp}}
            </router-link>
          </td>
          <td v-if="property.int_property_id !== propertyId && property.room">{{ language ==='english' ? property.room.str_room_short_name_en : property.room.str_room_short_name_jp}}</td>
          <td v-if="property.int_property_id !== propertyId">{{ property.flt_size }}m<sup>2</sup></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'listing-related-properties',
    props: {
      building: Object,
      propertyId: Number
    },
    computed: {
          ...mapState({
              language: (state) => {
                  return state.general.language
              }
          })
      },
    created() {
    },
    data() {
      return {
        tableData: [{
          date: '2016-05-03',
          name: 'Tom',
          address: 'No. 189, Grove St, Los Angeles'
        }, {
          date: '2016-05-02',
          name: 'Tom',
          address: 'No. 189, Grove St, Los Angeles'
        }, {
          date: '2016-05-04',
          name: 'Tom',
          address: 'No. 189, Grove St, Los Angeles'
        }, {
          date: '2016-05-01',
          name: 'Tom',
          address: 'No. 189, Grove St, Los Angeles'
        }]
      }
    }
  }
</script>

<style lang="scss">
  .RelatedProperties {
    display: inline-block;
    width: 100%;

    table {
      border-collapse: collapse;
      border-spacing: 0;
      width: 100%;
      table-layout: auto;

      tbody {
        padding: 0;
      }

      tr {
        td, th {
          &:first-child {
            padding-left: 0;
          }
        }
      }

      thead th {
        border-width: 1px;
      }

      th,
      td {
        text-align: left;
        padding: .5rem;
      }
    }

    caption {
      padding: 1rem 0;
      caption-side: bottom;
      color: rgb(253, 253, 253);
    }
  }
</style>



